<template>
  <el-card body-style="padding:0px 20px" shadow="never">
    <h3 class="common-title mb10">岗位亮点<el-button class="ml10" type="text" @click="toEdit">编辑</el-button></h3>
    <div class="card-content">
      <div class="project-detail-content">
        <div
          :class="[
            hasNotValueFields.includes('项目亮点及优势') ? 'warning-text' : '',
            'project-detail-content-title mb10',
          ]"
        >
          项目的亮点优势（1%<el-tooltip
            class="item"
            style="display:inline;color:#409EFF"
            effect="dark"
            content="业绩贡献率"
            placement="top"
            ><i class="el-icon-question"></i></el-tooltip
          >）：
        </div>
        <pre>{{ project.项目亮点及优势 || '暂无项目亮点及优势' }}</pre>
      </div>
      <div class="project-detail-content">
        <div
          :class="[
            hasNotValueFields.includes('职位劣势及风险点') ? 'warning-text' : '',
            'project-detail-content-title mb10',
          ]"
        >
          职位劣势及风险点：
        </div>
        <pre>{{ project.职位劣势及风险点 || '暂无职位劣势及风险点' }}</pre>
      </div>
      <div class="project-detail-content">
        <div
          :class="[hasNotValueFields.includes('部门详情') ? 'warning-text' : '', 'project-detail-content-title mb10']"
        >
          部门信息（1%<el-tooltip
            class="item"
            style="display:inline;color:#409EFF"
            effect="dark"
            content="业绩贡献率"
            placement="top"
            ><i class="el-icon-question"></i></el-tooltip
          >）：
        </div>
        <pre>{{ project.部门详情 || '暂无部门信息' }}</pre>
      </div>
      <div class="project-detail-content">
        <div
          :class="[hasNotValueFields.includes('阿尔法认知') ? 'warning-text' : '', 'project-detail-content-title mb10']"
        >
          阿尔法项目认知：
        </div>
        <pre>{{ project.阿尔法认知 || '暂无阿尔法项目认知' }}</pre>
      </div>
      <div class="project-detail-content">
        <div
          :class="[hasNotValueFields.includes('岗位薪酬') ? 'warning-text' : '', 'project-detail-content-title mb10']"
        >
          岗位薪酬：
        </div>
        <pre>{{ project.岗位薪酬 || '暂无岗位薪酬' }}</pre>
      </div>
    </div>

    <el-dialog
      :visible.sync="isEditing"
      custom-class="custom-dialog"
      append-to-body
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div slot="title" class="title">
        <div class="title-name">岗位亮点</div>
        <div class="side-title"></div>
        <!-- <div class="handle-btn">
          <el-button size="mini" type="text" @click="openHistory('项目基本信息')">操作记录</el-button>
        </div> -->
      </div>
      <div class="card-content">
        <div class="card-content-textarea-item">
          <span :class="[hasNotValueFields.includes('项目亮点及优势') ? 'warning-text' : '', 'field-label']"
            >项目的亮点优势（1%<el-tooltip
              class="item"
              style="display:inline;color:#409EFF"
              effect="dark"
              content="业绩贡献率"
              placement="top"
              ><i class="el-icon-question"></i></el-tooltip
            >）
          </span>
          <el-input
            v-model="projectInEdit.项目亮点及优势"
            class="mb15"
            type="textarea"
            :rows="2"
            placeholder="项目亮点及优势"
          ></el-input>
        </div>
        <div class="card-content-textarea-item">
          <span :class="[hasNotValueFields.includes('职位劣势及风险点') ? 'warning-text' : '', 'field-label']"
            >职位劣势及风险点
          </span>
          <el-input
            v-model="projectInEdit.职位劣势及风险点"
            class="mb15"
            type="textarea"
            :rows="2"
            placeholder="职位劣势及风险点"
          ></el-input>
        </div>
        <div class="card-content-textarea-item">
          <span :class="[hasNotValueFields.includes('部门信息') ? 'warning-text' : '', 'field-label']"
            >部门信息（1%<el-tooltip
              class="item"
              style="display:inline;color:#409EFF"
              effect="dark"
              content="业绩贡献率"
              placement="top"
              ><i class="el-icon-question"></i></el-tooltip
            >）
          </span>
          <el-input
            v-model="projectInEdit.部门详情"
            class="mb15"
            type="textarea"
            :rows="2"
            placeholder="部门信息"
          ></el-input>
        </div>
        <div class="card-content-textarea-item">
          <p :class="[hasNotValueFields.includes('阿尔法认知') ? 'warning-text' : '', 'field-label']">
            <span>阿尔法项目认知</span>
            <span v-if="project.职能模块 && company._id" class="text-btn ml10" @click="getCateCognition"
              >点击即可获得该公司“{{ project.职能模块 }}”职能模块的认知</span
            >
          </p>
          <el-input
            v-model="projectInEdit.阿尔法认知"
            class="mb15"
            type="textarea"
            :rows="2"
            placeholder="阿尔法认知"
          ></el-input>
        </div>
        <div class="card-content-textarea-item">
          <p :class="[hasNotValueFields.includes('岗位薪酬') ? 'warning-text' : '', 'field-label']">
            <span>岗位薪酬</span>
          </p>
          <el-input
            v-model="projectInEdit.岗位薪酬"
            class="mb15"
            type="textarea"
            :rows="2"
            placeholder="岗位薪酬"
          ></el-input>
        </div>
      </div>
      <div slot="footer">
        <el-row type="flex" align="center" justify="center">
          <el-button size="small" type="info" style="margin-right:20px" @click="cancelEdit">取消</el-button>
          <el-button size="small" type="primary" class="custom-primary-plain" @click="confirmEdit">保存</el-button>
        </el-row>
      </div>
    </el-dialog>
  </el-card>
</template>
<script>
import { defaultProject, defaultCompany } from '../../constant/defaultData'
import mixin from './mixin'

export default {
  mixins: [mixin],
  props: {
    project: { type: Object, default: () => window._.cloneDeep(defaultProject) },
    company: { type: Object, default: () => window._.cloneDeep(defaultCompany) },
    hasNotValueFields: { type: Array, default: () => [] },
  },
  data() {
    return {
      componentType: '亮点优势',
      fields: ['项目亮点及优势', '职位劣势及风险点', '部门详情', '阿尔法认知','岗位薪酬'],
    }
  },
  methods: {
    async getCateCognition() {
      const res = await app.service('company').getComCateCognition(this.company._id)
      if (res.status === 'success') {
        const cate = res.data.find(element => element.职能模块 === this.project.职能模块)
        if (cate && cate.职能模块认知) {
          if (!this.projectInEdit.阿尔法认知) this.$set(this.projectInEdit, '阿尔法认知', cate.职能模块认知)
          else this.$set(this.projectInEdit, '阿尔法认知', `${this.projectInEdit.阿尔法认知}\n${cate.职能模块认知}`)
        } else this.$message.error('该职能模块暂时没有职能模块认知')
      } else {
        this.$message.error(res.msg)
      }
    },
  },
}
</script>
<style scoped src="../../css/newProjectDetail.css"></style>
